<template>
	<div id="app" :style="{'--scale-rate': scaleRate()}">
		<router-view />
		<floating-window class="fade-in" :class="{'active': showFloating}"
			v-if="!isVerticalScreen()" />
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		getAction
	} from '@/api/index';
	import FloatingWindow from '@/components/controlsH/FloatingWindow.vue'
	export default {
		name: 'app',
		components: {
			FloatingWindow
		},
		data() {
			return {
				showFloating: false
			}
		},
		computed: {

		},
		mounted() {
			this.resetSetting();
			window.onresize = () => {
				return (() => {
					this.$nextTick(() => {
						this.resetSetting();
					});
				})();
			};
			window.addEventListener("orientationchange", () => {
				this.$nextTick(() => {
					this.resetSetting();
					location.reload();
				});
			})
			setTimeout(() => {
				this.showFloating = true;
			} ,100)
			this.preLoadData();
		},
		methods: {
			...mapGetters(["isVerticalScreen", "scaleRate"]),
			resetSetting() {
				const isVerticalScreen = window.innerWidth < window.innerHeight;
				this.$store.dispatch('setVerticalScreen', isVerticalScreen);
				this.$store.dispatch('setScaleRate',
					isVerticalScreen ? (window.innerWidth / 1126) : (window.innerWidth / 1920));
			},
			async preLoadData() {
				console.log('preLoadData')
				getAction('/officialWebsite/c-api/setting/home', {isCache: false})
				getAction('/officialWebsite/c-api/setting/home/productCat', {isCache: false})
				getAction('/officialWebsite/c-api/setting/subBrand', {isCache: false})
				getAction('/officialWebsite/c-api/coreTechnology/list', {isCache: false})
				getAction('/officialWebsite/c-api/setting/productPoster', {isCache: false})
				getAction('/officialWebsite/c-api/product/cat/list', {isCache: false})
				getAction('/officialWebsite/c-api/project/list', {isCache: false})
				getAction('/officialWebsite/c-api/setting/parkArea', {isCache: false})
				getAction('/officialWebsite/c-api/setting/companyProfile', {isCache: false})
				getAction('/officialWebsite/c-api/setting/corporateCulture', {isCache: false})
				getAction('/officialWebsite/c-api/setting/corporateHonors', {isCache: false})
				getAction('/officialWebsite/c-api/product/list', {isCache: false})
				getAction('/officialWebsite/c-api/setting/other', {isCache: false})
				getAction('/officialWebsite/c-api/channel/list', {isCache: false})
			}
		}
	}
</script>

<style>
	html,
	body,
	#app {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		-webkit-text-size-adjust: auto;
	}

	.single-line {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}

	.three-lines {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 3;
	}

	.inline-between {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	.inline-start {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}
	
	.inline-end {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	}

	.inline-column {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.inline-column-left {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
	}

	.inline-column-between {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.inline-start-b {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}
	.fade-in {
		opacity: 0;
		transition: opacity 1s ease-in-out;
	}
	
	.fade-in.active {
		opacity: 1;
	}
</style>